import {checkMenuDataItem} from './menu'


export const importId = 'import'
export const exportId = 'export'
export const importQtizipId = 'importQtizip'
export const importMsexcelId = 'importMsexcel'
export const exportQtizipId = 'exportQtizip'
export const exportMspowerpointId = 'exportMspowerpoint'
export const exportDocxId = 'exportDocx'
export const exportPdfId = 'exportPdf'
export const exportQuizId = 'exportQuiz'
export const exportPresentation = 'exportPresentation'


export const importExportMenuData = {
    [importId]: {
        id : importId,
        text: "Import",
        submenus: {
            [importQtizipId] : {
                id : importQtizipId,
                text : "QTI.zip",
                acceptedFormates : [
                    "multipart/x-zip",
                    "application/zip-compressed",
                    "application/x-zip-compressed",
                    "application/zip",
                ],
            },
            [importMsexcelId] : {
                id : importMsexcelId,
                text : "MS Excel",
                acceptedFormates : [
                    "application/vnd.ms-excel",
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                ]
            },
        }
    },
    [exportId] : {
        id : exportId,
        text: "Export",
        submenus: {
            [exportQtizipId] : {
                id : exportQtizipId,
                text : "QTI.zip",
                extension : "zip",
            },
            [exportDocxId] : {
                id : exportDocxId,
                text : "MS Word (.docx)",
                extension : "docx",
                modalTitle : "Export to MS Word (.docx) document",
            },
            [exportPdfId] : {
                id : exportPdfId,
                text : "PDF",
                extension : "pdf",
                modalTitle : "Export to PDF document",
            },
            [exportMspowerpointId] : {
                id : exportMspowerpointId,
                text : "MS PowerPoint",
                extension : "pptx",
            },
            [exportQuizId] : {
                id : exportQuizId,
                text : "Create Quiz",
                extension : "quiz",
            },
            [exportPresentation] : {
                id : exportPresentation,
                text : "txtSubMenuCreatePresentation",
                extension : "presenatation",
            },
        }
    },
}

export const getExportExtension = submenu => {
    return importExportMenuData[exportId].submenus[submenu] ?
            importExportMenuData[exportId].submenus[submenu].extension :
            ""
}

export const getImportAcceptedFormats = submenu => {
    return importExportMenuData[importId].submenus[submenu] ?
                importExportMenuData[importId].submenus[submenu].acceptedFormates.join(", ") :
                ""
}

export const checkImportFileType = (submenu, fileType) => {
    return importExportMenuData[importId].submenus[submenu] ?
                importExportMenuData[importId].submenus[submenu].acceptedFormates.includes(fileType) :
                false
}

export const stringifyAcceptedFormats = (submenu) => {
    return importExportMenuData[importId].submenus[submenu] ?
            importExportMenuData[importId].submenus[submenu].acceptedFormates.reduce(function (acc, curr, index, arr) {
                return acc += `.${curr}${index !== arr.length - 1 ? ", " : ""}`
            }, "") :
            ""
}


export const checkImportExportMenuDataItem = (...args) => {
    return checkMenuDataItem(importExportMenuData)(...args)
}

export const getExportModalTitle = (submenu) => {
    return importExportMenuData[exportId].submenus[submenu] ?
            importExportMenuData[exportId].submenus[submenu].modalTitle :
            ""
}


export const successExportMsg = 'Questions were successfully exported.'
export const labelExportName = 'Exported file will be named as:'
export const okExportText = 'Export'
export const cancelExportText = 'Cancel'
export const exportFormName = 'exportQuestions'


export const successImportMsg = 'Questions were successfully imported.'
export const okImportText = 'Import'


export const cancelImportText = 'Cancel'

export const importFormName = 'importQuestions'


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/helpers/importExport.js